import api from 'config/api';
import { Notification } from 'notification/notification';

export const getWhatsappConfig = async () => {
  try {
    const { data } = await api.get('whatsapp/v1/config');
    return data;
  } catch (err) {
    return null;
  }
};

export const saveWhatsappConfig = async (values) => {
  try {
    const { data, status } = await api.post('whatsapp/v1/config', values);
    Notification(status);
    return data;
  } catch (err) {
    Notification(500);
    return null;
  }
};

export const testWhatsappConnection = async () => {
  try {
    const { data } = await api.post('whatsapp/v1/config/test');
    return data;
  } catch (err) {
    return false;
  }
};

export const deleteWhatsappInstance = async () => {
  try {
    await api.delete('whatsapp/v1/config/instance');
    Notification(200, 'Dispositivo removido com sucesso!');
    return true;
  } catch (err) {
    Notification(500);
    return false;
  }
};

export const createWhatsappInstance = async () => {
  try {
    const { data } = await api.post('whatsapp/v1/config/create-instance');
    return data;
  } catch (err) {
    Notification(500);
    return false;
  }
};

export const getWhatsappQrCode = async () => {
  try {
    const { data } = await api.get('whatsapp/v1/config/qr');
    return data;
  } catch (err) {
    return null;
  }
};

export const getWhatsappMessages = async () => {
  try {
    const { data } = await api.get('whatsapp/v1/messages');
    return data || [];
  } catch (err) {
    Notification(500);
    return [];
  }
};

export const scheduleWhatsappMessage = async (values) => {
  try {
    const { data, status } = await api.post('whatsapp/v1/messages', values);
    Notification(status);
    return data;
  } catch (err) {
    if (navigator.onLine) Notification(500);
    return null;
  }
};

export const cancelWhatsappMessage = async (id) => {
  try {
    await api.delete(`whatsapp/v1/messages/${id}`);
    Notification(200);
  } catch (err) {
    Notification(500);
  }
};

export const sendWhatsappMessageNow = async (id) => {
  if (!navigator.onLine) return null;
  try {
    const { data, status } = await api.post(`whatsapp/v1/messages/${id}/send-now`);
    Notification(status);
    return data;
  } catch (err) {
    if (navigator.onLine) Notification(500);
    return null;
  }
};

export const retryWhatsappMessage = async (id) => {
  try {
    const { data, status } = await api.post(`whatsapp/v1/messages/${id}/retry`);
    Notification(status);
    return data;
  } catch (err) {
    Notification(500);
    return null;
  }
};

export const uploadWhatsappFile = async (file) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    const { data } = await api.post('whatsapp/v1/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return data;
  } catch (err) {
    Notification(500);
    return null;
  }
};

export const retryAllFailedMessages = async () => {
  try {
    const { data, status } = await api.post('whatsapp/v1/messages/retry-all-failed');
    Notification(status);
    return data;
  } catch (err) {
    Notification(500);
    return [];
  }
};
